import {Component, Input} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive} from "@angular/router";

@Component({
  selector: 'app-tab',
  standalone: true,
  imports: [
    RouterLink,
    RouterLinkActive
  ],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss'
})
export class TabComponent {
  @Input() text: string = '';
  @Input() link: string = '';

  constructor(public route: ActivatedRoute) {
  }
}
